import ProxyButton from '../common/ProxyButton';
import { getLocalizedString } from '../../utils/i18n-utils';

export default function WebAuthnVerifyButton({ oktaButton }: { oktaButton: JQuery }) {
  return (
    <ProxyButton
      oktaButton={oktaButton}
      fullWidth
      textToOverride={getLocalizedString('webauthn.try.again')}
    />
  );
}
